import React from 'react';
import ReactDOM from 'react-dom';
import ReactHtmlParser from 'react-html-parser';
import UrlManager from './../../model/UrlManager';
import CoreAjax from '../../util/CoreAjax';
import LoaderMask from '../../components/common/LoaderMask';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import RbUtil from './../../util/RbUtil';
import RbMeta from './../../util/RbMeta';
import RbTitle from './../../util/RbTitle';
import RbHeading from './../../util/RbHeading';
import TrackingManager from '../../model/event-structures';
import TimeUtil from '../../util/TimeUtil';
import HmEventRegistry from './../../model/HmEventRegistry';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import UserStorageUtil from '../../util/UserStorageUtil';
import browserStorageUtil from '../../util/BrowserStorageUtil';
import AdsTracker from '../../util/AdsTracker';
import ComponentHelper from '../../util/ComponentHelper';
import FileAppender from '../../util/FileAppender';

export default class CorePage extends React.Component{
	constructor(props) {
		super(props);
	}

	shouldComponentUpdate(nextProps, nextState) {
        if(nextState){
            for(let i in nextState){
                if(this.state[i] !== nextState[i]){
                    return true;
                }
            }
		}
		if(nextProps){
			for(let i in nextProps){
                if(this.props[i] !== nextProps[i]){
                    return true;
                }
            }
		}
        return false;
    }

	appendJS(url){
		new FileAppender(url).addVersion().js();
	}

	appendCSS(url){
		let isAvailable = false;
		try{
			let links = document.getElementsByTagName("link");
			if(links && links.length > 0){
				for(let l=0;l<links.length;l++){
					if(links[l].href.match(url)){
						isAvailable = true;
						break;
					}
				}			 
			}
		}catch(e){
			console.error(e);
		}

		if(!isAvailable){
			new FileAppender(url).addVersion().css();
		}	   
	}

	getCmpHelper(userStore){
		return ComponentHelper(userStore);
	}

	getTimeUtil(){
		return new TimeUtil();
	}

	getContestHost(){
		if(localStorage.getItem("contestType") && localStorage.getItem("contestType").length > 0){
			return localStorage.getItem("contestType").toUpperCase();
		}

		return null;
	}

	getTracker(){
		return TrackingManager;
	}

	isMobile(){
		return isMobile;
	}

	isTab(){
		return isTablet;
	}

	isBrowser(){
		return isBrowser;
	}

	getSessionStore(){
		return UserStorageUtil;
	}

	saveInSession(key, value){
		UserStorageUtil.storeSessionItem(key, value);
	}

	getFromSession(key){
		return UserStorageUtil.getStoredSessionItem(key);
	}

	getAdsTracker(){
		return AdsTracker;
	}

	getBasePath(filePath = null){
		return (filePath) ? ((filePath.startsWith("/")) ?  window.location.origin+filePath : window.location.origin+"/"+filePath) : window.location.origin;
	}

	applyGaParams(key, value){
		window.ga_data = (typeof window.ga_data === "object") ? window.ga_data : {};
		if(key && value){
			window.ga_data[key] = value;
		}
	}

	sessionCheck(successCallback, failureCallBack, forceTrigger){
		
		var me = this;
		var success = function(userObj, opts){
			if(opts && !isNaN(opts.timeTakenInSecs) && opts.timeTakenInSecs >= 2){
 				//Trigger NET_CHECK to check internet
 				HmEventRegistry.fireEvent("NET_CHECK");
 			}

			 try{
				if(userObj && userObj.loginId){
					me.applyGaParams("role",userObj.userRole.role);
				}
			 }catch(e){}

			if(typeof successCallback === "function"){
				successCallback.apply(this, [userObj]);
			}
		}
		var failure = function(error, opts){
			//Trigger NET_CHECK to check internet
 			HmEventRegistry.fireEvent("NET_CHECK");
			
			if(typeof failureCallBack === "function"){
				failureCallBack.apply(this, [error]);
			}
		}

		if(forceTrigger || this.isSessionCheckEligible()){
			new CoreAjax(me.getUrlFor("SESSION_CHECK")).get(success,failure);	
			
			if(forceTrigger){
				browserStorageUtil.storeItem("LAST_SESSION_CHECK", ((new Date().getTime()) / 1000));
			}
		}else{
			var storedUserObj = this.getStoredUser();
			if(storedUserObj){
				if(typeof successCallback === "function"){
					successCallback.apply(this, [storedUserObj]);
				}
			}else{
				if(typeof failureCallBack === "function"){
					failureCallBack.apply(this, [{sessionChecked:false}]);
				}
			}
		}
	}

	isSessionCheckEligible(){
		let storedUser = this.getStoredUser();
		let storedUserId = (storedUser && storedUser.userId) ? storedUser.userId : null;
		
		if(!(storedUserId && storedUserId.length > 0)){
			return true;
		}		

		let DEFAULT_INTERVAL_IN_SECS = (!isNaN(window.sessionCheckInterval) && window.sessionCheckInterval > 0) ? window.sessionCheckInterval : 15;

		try{
			let dt = (new Date().getTime()) / 1000;
			let oldDt = browserStorageUtil.getStoredItem("LAST_SESSION_CHECK");

			if(!isNaN(oldDt) && (dt - oldDt) <= DEFAULT_INTERVAL_IN_SECS){
				return false;
			}else{
				browserStorageUtil.storeItem("LAST_SESSION_CHECK", dt);
			}
		}catch(e){}
		
		return true;
	}

	getStoredUser(){
		return this.getFromSession("USER_DETAILS");
	}

	setLocale(locale){
		RbUtil.setLocale(locale);
		RbMeta.setLocale(locale);
		RbTitle.setLocale(locale);
		RbHeading.setLocale(locale);
	}

	rb(rawTxt,replaceStringArray=[]){
		return RbUtil.getText(rawTxt,replaceStringArray);
	}

	getLocales(){
		return RbUtil.getLocales();
	}

	getTitle(rawTxt,replaceStringArray=[]){
		return RbTitle.getText(rawTxt,replaceStringArray);
	} 

	setTitle(rawTxt,replaceStringArray=[]){
		document.title=this.getTitle(rawTxt,replaceStringArray)
	}

	getMeta(rawTxt,replaceStringArray=[]){
		return RbMeta.getText(rawTxt,replaceStringArray);
	} 

	setMeta(rawTxt,replaceStringArray=[]){
		var me = this;
		//document.body.onload = ()=> {

			var metas = document.getElementsByTagName("meta");
			if(metas && metas.length > 0){
				for(var i=0; i < metas.length; i++){
					if(metas[i].name === "description"){
						var descMeta = metas[i];
						descMeta.content = me.getMeta(rawTxt,replaceStringArray);
					}				
				}
			} 
		//}
	}
	getHeading(rawTxt,replaceStringArray=[]){	
		return RbHeading.getText(rawTxt,replaceStringArray);
	} 
	
	
	setHeading(rawTxt,replaceStringArray=[]){
		var heading = document.getElementById("hidden-h1");
		heading.textContent = this.getHeading(rawTxt,replaceStringArray);		
		
	}

	fireEvent(event, obj){
		if(event){
			HmEventRegistry.fireEvent(event, obj);
		}
	}

	getUrlFor(action){
		return UrlManager.getUrlForAction(action);
	}

	getUriFor(action){
		return UrlManager.getUriForAction(action);	
	}

	showLoader(type="Oval"){
		return(
			<div><LoaderMask type={type} /></div>
			)
		}

	showMask(customComponent){
		ReactDOM.render(<div className="overlay_cont">
		{customComponent}
    	</div>, document.getElementById('subroot'));
	}

	hideMask(){
		ReactDOM.unmountComponentAtNode(document.getElementById('subroot'));
	}


		showAlert(title,message, btnHandlers,btnshw = null,closeOnClickOutside=false){
			var me = this;

			var buttons = [];

			try{
				if(btnHandlers !== undefined && btnHandlers !== null && btnHandlers.length > 0){
					for(var i=0;i<btnHandlers.length; i++){
						buttons.push({
							label: btnHandlers[i].label || me.rb("btn.ok"),
							onClick: (typeof btnHandlers[i].handler === "function") ? btnHandlers[i].handler : () => {}
						})
					}
				}
			}catch(e){}

			if(buttons.length == 0 && btnshw == null){
				buttons.push({
					label: 'Ok',
					onClick: () => {}
				});
			}

			return confirmAlert({
				title: title || 'Alert',
				message: message ? ReactHtmlParser(message) : 'Hello..',
				buttons: buttons,
				closeOnClickOutside : closeOnClickOutside || false
			}); 
		}

		removeWhiteSpace(str){
			return str.replace(/ +/g, "");
		}

		reactHtmlParser(txt){
			if(txt){
				return ReactHtmlParser(txt);
			}

			return txt;			
		}

		epochTimeFn(str,repTxt=''){
			let replaceTxt = repTxt;
			let timeVal = replaceTxt;
			if(str>0){
			  var d = new Date(Number(str) * 1000);
			  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
			  var n = (d.toDateString());
			  timeVal = d.getDate() +" "+ months[d.getMonth()] +"  "+d.getFullYear(); //n.substring(4,n.length);
			}
			return timeVal;
		}
	
		formatAMPM(str,repTxt=''){
			let replaceTxt = repTxt;
			let strTime = replaceTxt;
			if(str>0){
			  let date = new Date(Number(str) * 1000);
			  var hours = date.getHours();
			  var minutes = date.getMinutes();
			  var ampm = hours >= 12 ? 'pm' : 'am';
			  hours = hours % 12;
			  hours = hours ? hours : 12; // the hour '0' should be '12'
			  hours = hours < 10 ? '0'+hours : hours;
			  minutes = minutes < 10 ? '0'+minutes : minutes;
			  strTime = hours + ':' + minutes + ' ' + ampm;
			}
			return strTime;
		}

		render() {
			return(
			<div><LoaderMask /></div>
			)
		}
	}


// WEBPACK FOOTER //
// ./src/views/core/CorePage.js